module.exports = __webpack_public_path__ + "img/1945_Karl-Maria-Stepan.ff19f260.jpg";